export default {"src":"/_next/static/media/booking.3912c8f8.svg","height":84,"width":75,"blurWidth":0,"blurHeight":0};